(function() {
    $('.jsContentShowMore').click( function(e) {
        e.preventDefault();

        $('.boxContent').toggleClass('boxContent--active');

        $('.ContentShowMore').hide();

        $('html, body').animate({
            scrollTop: $('.boxContent').offset().top - 20
        }, 500);

    });
})();
